'use client';
import cn from 'classnames';
import './EllaCartSubtotal.style.scss';
import { useEffect, useState } from 'react';
import { USDFormatter } from '@/util/currency';
import Text from '../Text/Text';

type EllaCartSubtotalProps = {
  className?: string;
  hasDiscount?: boolean;
  discountAmountPercentage?: number;
  subtotal: number;
  shipping: number;
  taxes: number;
};

function EllaCartSubtotal(props: EllaCartSubtotalProps) {
  const {
    className = '',
    hasDiscount = false,
    discountAmountPercentage,
    subtotal,
    shipping = 0,
    taxes
  } = props;
  const [total, setTotal] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);

  useEffect(() => {
    let totalNumber = subtotal;
    if (hasDiscount && discountAmountPercentage) {
      const discountAmountNumber =
        Number(subtotal) * (Number(discountAmountPercentage) / 100);
      setDiscountAmount(discountAmountNumber);
      totalNumber = Number(subtotal) - discountAmountNumber;
    }

    if (shipping > 0) {
      totalNumber += shipping;
    }

    setTotal(totalNumber + taxes);
  }, [discountAmountPercentage, hasDiscount, shipping, subtotal, taxes]);

  return (
    <div className='EllaCartSubtotal'>
      <div className={cn('EllaCartSubtotalLine', className)}>
        <Text
          variant='title-xxs-600-upper'
          className='SubtotalLineField TitleField'
        >
          SUBTOTAL:
        </Text>
        <Text
          variant='title-xxs-600-upper'
          className='ValueField'
        >
          {USDFormatter.format(subtotal / 100)}
        </Text>

        {hasDiscount && discountAmountPercentage && (
          <>
            <Text
              variant='title-xxs-600-upper'
              className='TitleField'
            >
              {discountAmountPercentage}% DISCOUNT:
            </Text>
            <Text
              variant='title-xxs-600-upper'
              className='ValueField'
            >
              - {USDFormatter.format(discountAmount)}
            </Text>
          </>
        )}
      </div>
      <div className={cn('EllaCartSubtotalLine', className)}>
        <Text
          variant='title-xxs-600-upper'
          className='TitleField'
        >
          SHIPPING:
        </Text>
        <Text
          variant='title-xxs-600-upper'
          className='ValueField'
        >
          {shipping === 0 ? 'FREE' : USDFormatter.format(shipping / 100)}
        </Text>
        <Text
          variant='title-xxs-600-upper'
          className='TitleField'
        >
          TAXES:
        </Text>
        <Text
          variant='title-xxs-600-upper'
          className='ValueField'
        >
          {USDFormatter.format(taxes / 100)}
        </Text>
        <Text
          variant='title-xxs-700-upper'
          className='TitleField Total'
        >
          TOTAL:
        </Text>
        <Text
          variant='title-xxs-700-upper'
          className='ValueField TotalValue'
        >
          {USDFormatter.format(total / 100)}
        </Text>
      </div>
    </div>
  );
}

export default EllaCartSubtotal;
